import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Zarządza pozycją scrolla przy zmianie trasy.
 *
 * Router nie robi tego sam: po wejściu na artykuł z połowy listy strona
 * zostałaby przewinięta w tym samym miejscu, a link `/#oferta` z podstrony
 * bloga wylądowałby na górze strony głównej zamiast przy sekcji.
 *
 * `location.key` w zależnościach jest celowo — dzięki niemu ponowne kliknięcie
 * tego samego linku kotwicowego znów przewija, tak jak zachowuje się zwykły
 * `<a href="#...">`.
 */
export default function ScrollManager() {
  const { pathname, hash, key } = useLocation()

  useEffect(() => {
    if (hash) {
      // rAF — dajemy nowej trasie domalować się, zanim szukamy elementu.
      const frame = requestAnimationFrame(() => {
        document
          .querySelector(hash)
          ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
      return () => cancelAnimationFrame(frame)
    }

    window.scrollTo({ top: 0, left: 0 })
  }, [pathname, hash, key])

  return null
}
